import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ConnectedProps, connect } from 'react-redux';
import { useQueryCountInAppObrasNotifications } from 'Hooks/notifications/useQueryCountInAppObrasNotifications';
import useObra, { SEARCH_LOCAL_STORAGE_KEY } from './useObra';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import BoxContainer from 'Components/UI/Containers/BoxContainer/BoxContainer';
import PageHeader from 'Components/UI/PageHeader/PageHeader';
import ListContainer from 'Components/UI/Containers/ListContainer/ListContainer';
import ActionMenuObra from 'Components/UI/ActionMenu/ActionMenuItem';
import Button from 'Components/UI/Button';
import LoadingObras from 'Components/UI/CustomLoading/LoadingObras';
import ObrasItem from './components/ObrasItem';
import ObraArquivada from './components/ObraArquivada';
import { HeaderActions } from './components/HeaderActions';
import { SearchRow } from './components/SearchRow';
import AvisoUsuarioUpgrade from '../SharedModals/AvisoUsuarioUpgrade';
import CadastroObra from './Modals/CadastroObra';
import ConexaoServico from './Modals/ConexaoServico';
import AvisoObraUpgrade from './Modals/AvisoObraUpgrade';
import UsuariosEPermissoes from './Modals/UsuariosEPermissoes';
import { formatDateByTime } from 'Utils/DateUtils';
import AppStorage from 'Utils/AppStorage';
import { GetAvatar } from 'Utils/generateThumbnail';
import {
  ListaObrasArquivadas,
  ObrasWrapper,
  WithoutConstruction,
} from './styles';

import engineerImg from 'Static/images/engineer.png';

const Obras: FC<Props> = ({
  isLoading,
  ObrasList,
  minhaConta,
  notification,
  planFree,
  userInfo,
  isLoadingGetUsersConstruction,
  Users,
  userLimitsActive,
  usersForLimitInvited,
  clearConstructionSiteSearch,
}) => {
  const { t } = useTranslation('obras');
  const { data: notificationsCount } = useQueryCountInAppObrasNotifications();

  const {
    usuariosEPermissoesVisible,
    cadastroObraVisible,
    isEditObra,
    conexaoServicoVisible,
    csIdConexaoServico,
    modalContaUpgradeVisible,
    modalUsuarioUpgradeVisible,
    isSearchSubmited,
    obrasArquivadas,
    obrasForShow,
    filteredObras,
    constructionSiteSearch,
    obras,
    maxObras,
    maxUsers,
    setConstructionSiteSearch,
    removeSearch,
    setIsSearchSubmited,
    setModalContaUpgradeVisible,
    setCadastroObraVisible,
    setUsuariosEPermissoesVisible,
    setConexaoServicoVisible,
    closeModalContaUpgrade,
    setModalUsuarioUpgradeVisible,
    openConexaoServico,
    openUsuariosEPermissoes,
    openCadastroObra,
    upgradePlanRedirect,
  } = useObra({
    isLoading,
    ObrasList,
    userInfo,
    isLoadingGetUsersConstruction,
    Users,
    userLimitsActive,
    clearConstructionSiteSearch,
  });

  return (
    <ObrasWrapper>
      <PageHeader
        name={t('pageTitle')}
        showCount
        count={filteredObras?.length}
        isFiltered={!!constructionSiteSearch}
        actions={
          <HeaderActions
            isLoading={isLoading}
            minhaConta={minhaConta}
            obras={obras}
            obrasForShow={obrasForShow}
            openCadastroObra={openCadastroObra}
            onSearchChange={(search) => setConstructionSiteSearch(search)}
            onRemoveSearch={removeSearch}
            onSearch={(search) => {
              setConstructionSiteSearch(search);
              setIsSearchSubmited(true);
              AppStorage.SetItem(SEARCH_LOCAL_STORAGE_KEY, search, 'local');
            }}
          />
        }
      >
        <SearchRow
          obrasForShow={obrasForShow}
          show={isSearchSubmited}
          search={constructionSiteSearch}
          onRemoveSearch={removeSearch}
          count={filteredObras?.length}
        />

        {isLoading || obras === undefined ? (
          <LoadingObras multiple={6} />
        ) : (
          <>
            {filteredObras?.map((obra) => (
              <BoxContainer key={obra.ConstructionSiteId}>
                <ActionMenuObra
                  constructionSiteName={obra.Name}
                  constructionSiteId={obra.ConstructionSiteId}
                  activeObrasCount={obras && obras.length}
                  openInviteUser={() => openUsuariosEPermissoes(obra.ConstructionSiteId)}
                >
                  <ObrasItem
                    constructionSiteId={obra.ConstructionSiteId}
                    image={obra?.AvatarFileName
                      ? `${process.env.REACT_APP_IMAGE_STORAGE_URL?.replace('hom', 'prod')}${obra.AvatarFileName}`
                      : obra?.OriginalImageUrl
                    }
                    thumbSrc={obra?.ThumbnailImageUrl}
                    thumbType='big'
                    name={obra.Name}
                    isConnectedApi={obra.isConnectedApi}
                    data={formatDateByTime(new Date(obra.LastUpdateUtc))}
                    openUsuariosEPermissoes={() =>
                      openUsuariosEPermissoes(obra.ConstructionSiteId)
                    }
                    openConexaoServico={() => openConexaoServico(obra.ConstructionSiteId)}
                    sharedUsers={obra.SharedUsers}
                    currentPeperUser={minhaConta.CurrentRoleFk}
                    notification={notification}
                    notificationsCount={notificationsCount}
                    search={{ show: !isSearchSubmited && !!constructionSiteSearch, search: constructionSiteSearch }}
                  />
                </ActionMenuObra>
              </BoxContainer>
            ))}
          </>
        )}
      </PageHeader>

      {obras && !obras.length && (
        <WithoutConstruction>
          <img src={engineerImg} alt='Engineer' />
          <span className='title'>
            {t('noObrasMessage')}
          </span>
          <Button
            className='buttonTour'
            onClick={() => window.open('https://youtu.be/FeBXPmpL2og', '_blank')}
          >
            {t('needHelpButton')}
          </Button>
        </WithoutConstruction>
      )}

      {obrasArquivadas?.length ? (
        <PageHeader
          name={t('archivedTitle')}
          showCount
          count={obrasArquivadas.length}
          isCollapsiable
        >
          <ListaObrasArquivadas>
            {obrasArquivadas?.map((obra) => (
              <ListContainer key={`obraArquivada${obra.ConstructionSiteId}`}>
                <ObraArquivada
                  ConstructionSiteId={obra.ConstructionSiteId}
                  avatar={<GetAvatar name={obra.Name} shape='circle' size='large' />}
                  name={obra.Name}
                  currentPeperUser={minhaConta.CurrentRoleFk}
                  activeObras={userLimitsActive?.QtyActiveConstructionSites ?? 0}
                  maxObras={maxObras}
                  setModalContaUpgradeVisible={setModalContaUpgradeVisible}
                  isLoading={isLoading}
                />
              </ListContainer>
            ))}
          </ListaObrasArquivadas>
        </PageHeader>
      ) : (
        ''
      )}

      {cadastroObraVisible && <CadastroObra
        isVisible={cadastroObraVisible}
        isEdit={isEditObra}
        onCancel={() => setCadastroObraVisible(false)}
        firstInvitedUsers={usersForLimitInvited}
      />}
      {usuariosEPermissoesVisible && <UsuariosEPermissoes
        isVisible={usuariosEPermissoesVisible}
        onCancel={() => setUsuariosEPermissoesVisible(false)}
        maxUsers={maxUsers}
        firstInvitedUsers={usersForLimitInvited}
      />}
      {conexaoServicoVisible && <ConexaoServico
        csId={csIdConexaoServico}
        isVisible={conexaoServicoVisible}
        onCancel={() => setConexaoServicoVisible(false)}
      />}
      {modalContaUpgradeVisible && <AvisoObraUpgrade
        visible={modalContaUpgradeVisible}
        onCancel={closeModalContaUpgrade}
        onConfirm={upgradePlanRedirect}
        planFree={planFree}
        order={userInfo?.UserStoreItem.StorePlan?.Order}
        role={minhaConta.CurrentRoleFk}
      />}
      {modalUsuarioUpgradeVisible && <AvisoUsuarioUpgrade
        visible={modalUsuarioUpgradeVisible}
        onCancel={() => setModalUsuarioUpgradeVisible(false)}
      />}
    </ObrasWrapper>
  );
};

const mapState = (state: IGlobalReducerState) => ({
  ...state.obra,
  ...state.auth,
  isLoading: state.obra.isLoading,
  minhaConta: state.minhaConta.userInfo,
  registerCompleted: state.minhaConta.userInfo?.isRegisterComplete,
  notification: state.notification.notificationsMap,
});

const connector = connect(mapState);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;

export default connector(Obras);
